/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 */
import cx from 'classnames';

import type { ScrollAreaProps } from '../../types';
import './ScrollArea.less';

const ScrollArea = ({ maxHeight = 240, className, children }: ScrollAreaProps) => (
  <div
    className={cx('scroll-area', className)}
    style={{ maxHeight: typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight }}>
    {children}
  </div>
);

ScrollArea.displayName = 'ScrollArea';
export default ScrollArea;
